export default "__VITE_ASSET__DQT2kOz4__"